const ajaxFetch = ajax_object.ajaxurl;
const methodPost = 'POST';

function fetchData(url, headers, body, method, responseType, thenHandler, catchHandler) {
    fetch(url, {
        method: method,
        headers: headers,
        body: body
    })
    .then(response => {
        if (responseType === 'json') {
            return response.json();
        } else if (responseType === 'text') {
            return response.text();
        } else {
            return response;
        }
    })
    .then(data => {
        thenHandler(data);
    })
    .catch(error => {
        catchHandler(error);
    });
}


function handleFormSubmission(formId, ajaxAction, responseType) {
    const updateDataForm = document.getElementById(formId);
    if(updateDataForm) {
        updateDataForm.addEventListener('submit', function(event) {
            event.preventDefault();

            const honeypotField = document.getElementById('company_name');
            if (honeypotField.value !== '') {
                console.log('Honeypot field is filled. Likely spam submission.');
                return;
            }

            let formData = new FormData(this);

            const headers = {
                'Content-Type': 'application/x-www-form-urlencoded'
            };
            const body = new URLSearchParams({
                action: ajaxAction,
                formData: JSON.stringify(Object.fromEntries(formData)),
            });
            const thenHandler = (data) => {
                console.log(data);
                if (data.success) {
                    if (data.redirect_url) {
                        // Redirect to the newly created post or updated post's page
                        window.location.href = data.redirect_url;
                    } else {
                        // Reload the current page to show updated information
                        location.reload();
                    }
                } else {
                    console.log('Form submission failed: ' + data.message);
                }
            };
            const catchHandler = (error) => {
                console.error('Error:', error);
            };

            fetchData(ajaxFetch, headers, body, methodPost, responseType, thenHandler, catchHandler);
        });
    }
}

document.addEventListener('DOMContentLoaded', function() {

    function hideElements() {
        const btnClose = document.getElementById('btnClose');
        const modalLabel = document.getElementById('contactUsModalLabel');
        const modalHr = document.querySelector('.modal-body > hr');
        const modalBody = document.getElementById('contactUsModalBody');
        if (modalLabel) modalLabel.textContent = 'Thank you for reaching out!';
        if (btnClose) btnClose.classList.add('d-none');
        if (modalHr) modalHr.classList.add('d-none');
        if (modalBody) modalBody.classList.add('d-none');
    }

    function checkForConfirmation() {
        const confirmationMessage = document.querySelector('.gform_confirmation_message');
        if (confirmationMessage) {
            hideElements();
        }
    }

    const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length > 0) {
                checkForConfirmation();
            }
        });
    });

    const modalContent = document.querySelector('#contactUsModal .modal-content');
    if (modalContent) {
        observer.observe(modalContent, { childList: true, subtree: true });
    }

    checkForConfirmation();
});


export { 
    ajaxFetch, 
    methodPost, 
    fetchData, 
    handleFormSubmission
};